import React from 'react';
import Section from '../components/Section';
import Header from '../components/Header';
// import ScheduleSlideContainer from '../containers/ScheduleSlide.container';
import MaterialContainer from '../containers/Materials.container';
import PhotoVideoContainer from '../containers/PhotoVideo.container';
import HomeContainer from '../containers/Home.container';
import MedalContainer from '../containers/MedalTable.container';
import SectionSportsIcons from '../components/SectionSportsIcons';
import CalendarContainer from '../containers/Calendar.container';


const Index = () => (
    <React.Fragment>
        <Header mod={'page__header_index'} />
        <SectionSportsIcons />
        <Section
            title="Расписание"
            button={{ href: '/olympic2018/kalendar-olimpiada-2018#', text: 'Полное расписание' }}
            mod={'slide'}
        >
            <CalendarContainer />
        </Section >
        <Section title="Главное">
            <HomeContainer />
        </Section>
        <Section title="Медальный зачет" mod={'colored'} button={{ href: '/olympic2018/medalnyj-zachet-olimpiada-2018#', text: 'Весь медальный зачет' }}>
            <MedalContainer limits={5} />
        </Section>
        <Section
            title="Материалы"
            button={{ href: '/olympic2018/materials#', text: 'Все материалы' }}
        >
            <MaterialContainer mlimits={7} nlimits={8} />
        </Section>
        <Section title="Фото&Видео" mod={'colored'}>
            <PhotoVideoContainer />
        </Section>

    </React.Fragment>
);

export default Index;



// WEBPACK FOOTER //
// ./src/pages/Index.jsx